import React from "react";
import s from "./Placeholder.module.scss";

/**
 * @param {Object} props 
 * @param {boolean} props.highContract - should be true for disabled inputs for higher contrast
 * @param {React.ReactNode | React.ReactNode[]} props.children
 */
const Placeholder = ({ highContract, children }) => {
  return <div className={highContract ? s["placeholder-dark"] : s["placeholder"]}>{children}</div>;
};

export default Placeholder;
